import { render, staticRenderFns } from "./TestBarChart.vue?vue&type=template&id=230d77bf&"
import script from "./TestBarChart.vue?vue&type=script&lang=js&"
export * from "./TestBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports